import React, { useEffect, useState } from "react";
import { Badge, Dropdown, Table } from "flowbite-react";
import LightSpinner from "../../../components/LightSpinner";
import {
  useGetClusterQuery,
  useGetLeaderboardQuery,
} from "../../../graphql/generated.tsx";
import formatDate from "../../Admin/Helpers/formatDate.jsx";
import { Link } from "react-router-dom";
import { FaMedal } from "react-icons/fa"; // Importing FontAwesome icons

const Leaderboard = ({ clusterId, campusName }) => {
  const {
    data: leaderboardData,
    loading: leaderboardLoading,
    error: leaderboardError,
    refetch,
  } = useGetLeaderboardQuery({
    variables: { campusName, clusterId, filter: "custom", page: 1, limit: 10 },
  });

   const [Isload, setIsload] = useState(true);

   useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);

  const {
    data: clusterData,
    loading: clusterLoading,
    error: clusterError,
  } = useGetClusterQuery({
    variables: { campusName, clusterId },
  });

  useEffect(() => {
    refetch({ campusName, clusterId, filter: "custom", page: 1, limit: 10 });
  }, [campusName, clusterId, refetch]);

  if (leaderboardLoading || clusterLoading || Isload) {
    return (
      <div className="flex items-center justify-center h-screen">
        <LightSpinner size="xl" />
      </div>
    );
  }

  if (leaderboardError || clusterError) {
    return (
      <div className="text-center text-red-600">
        <p>
          Error:{" "}
          {leaderboardError ? leaderboardError.message : clusterError.message}
        </p>
      </div>
    );
  }

  const leaderboard = leaderboardData.getLeaderboard;

  const getPositionIcon = (position) => {
    switch (position) {
      case 1:
        return (
          <div className="flex items-center justify-center gap-2">
            1 <FaMedal className="text-yellow-400" />
          </div>
        );
      case 2:
        return (
          <div className="flex items-center justify-center gap-2">
            2 <FaMedal className="text-gray-400" />
          </div>
        );
      case 3:
        return (
          <div className="flex items-center justify-center gap-2">
            3 <FaMedal className="text-orange-400" />
          </div>
        );
      default:
        return position;
    }
  };

  return (
    <>
      {leaderboard.length > 0 ? (
        <div className="p-4 my-10 bg-white rounded-lg shadow dark:bg-gray-800 sm:p-6 xl:p-8">
          <div className="flex items-center justify-between mb-4">
            <div>
              <h3 className="mb-2 text-2xl font-bold text-gray-900 dark:text-white">
                {clusterData?.getCluster?.name}'s Top 10 Leaderboard
              </h3>
            </div>
          </div>
          <div className="overflow-x-auto">
            <Table striped className="min-w-full">
              <Table.Head className="bg-primary">
                <Table.HeadCell className="text-white bg-primary">
                  Position
                </Table.HeadCell>
                <Table.HeadCell className="text-center text-white bg-primary">
                  Name
                </Table.HeadCell>
                <Table.HeadCell className="text-center text-white bg-primary">
                  Email
                </Table.HeadCell>
                <Table.HeadCell className="text-center text-white bg-primary">
                  Points
                </Table.HeadCell>
                <Table.HeadCell className="text-center text-white bg-primary">
                  Last Submission
                </Table.HeadCell>
                <Table.HeadCell className="text-center text-white bg-primary">
                  Questions Completed
                </Table.HeadCell>
              </Table.Head>
              <Table.Body className="bg-white dark:bg-gray-800">
                {leaderboard.length > 0 ? (
                  leaderboard.map((student, index) =>
                    student.student ? (
                      <Table.Row key={index}>
                        <Table.Cell className="text-sm font-normal text-center text-gray-900 dark:text-white">
                          {getPositionIcon(student.position)}
                        </Table.Cell>
                        <Table.Cell className="text-sm font-normal text-center text-gray-900 dark:text-white">
                          {student.student.name}
                        </Table.Cell>
                        <Table.Cell className="text-sm font-normal text-center text-gray-900 dark:text-white">
                          {student.student.email}
                        </Table.Cell>
                        <Table.Cell className="text-sm font-normal text-center text-gray-500 dark:text-gray-400">
                          {student.totalScore}
                        </Table.Cell>
                        <Table.Cell className="text-sm font-semibold text-center text-gray-900 dark:text-white">
                          {formatDate(student.latestSubmissionDate)}
                        </Table.Cell>
                        <Table.Cell className="text-sm font-normal text-center text-gray-900 dark:text-white">
                          {student.completedQuestions || 0}
                        </Table.Cell>
                      </Table.Row>
                    ) : null
                  )
                ) : (
                  <Table.Row>
                    <Table.Cell
                      colSpan="5"
                      className="text-sm font-normal text-center text-gray-500 dark:text-gray-400"
                    >
                      No data available
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </div>
          <div className="flex flex-col items-center justify-between pt-3 sm:flex-row sm:pt-6">
            <div className="mb-2 shrink-0 sm:mb-0">
              <Link
                to={`/student/courses/${clusterId}`}
                className="inline-flex items-center p-2 text-xs font-medium uppercase rounded-lg text-primary-700 hover:bg-gray-100 dark:text-primary-500 dark:hover:bg-gray-700 sm:text-sm"
              >
                Continue to Courses
                <svg
                  className="w-4 h-4 ml-1 sm:h-5 sm:w-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Leaderboard;
